export const FiledNameKeyMapping = {
  ['Email']: 'general.customer.email',
  ['Mobile Number']: 'general.customer.mobileNumber',
  ['MobileNumber']: 'general.customer.mobileNumber',
  ['Title']: 'general.customer.title2',
  ['First Name']: 'general.customer.firstName',
  ['FirstName']: 'general.customer.firstName',
  ['Last Name']: 'general.customer.lastName',
  ['LastName']: 'general.customer.lastName',
  ['Full Name']: 'general.customer.fullName',
  ['FullName']: 'general.customer.fullName',
  ['Gender']: 'general.customer.gender',
  ['Date of Birth']: 'general.customer.dob',
  ['Cross-border Name']: 'general.customer.crossborderName',
  ['Language']: 'general.customer.language',
};

export const FieldTypeKeyMapping = {
  ['Input Field']: 'general.inputField',
  ['Selector']: 'general.selector',
};

export const OptionKeyMapping = {
  ['Male']: 'general.customer.male',
  ['Female']: 'general.customer.female',
};

export const DOBKeyMapping = {
  ['Year']: 'general.fieldModal.year',
  ['Month']: 'general.fieldModal.month',
  ['Day']: 'general.fieldModal.date',
};
